export default [
    // 此处是复制以下几个菜单，统一在成本计费大菜单之下，后续菜单命名不一样
    // 计费单、费用明细、账单管理、调账、费率模板管理、客户费率
    {
        path: "costbilling/billorder/list",
        name: "costbillingOrderList",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billorder/index"),
    },
    {
        path: "costbilling/billorder/update/:type",
        name: "costbillingOrderUpdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billorder/update"),
    },
    // 费用明细
    {
        path: "costbilling/costdetail/wareindex",
        name: "costbillingWareindex",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/costdetail/wareindex"),
    },
    {
        path: "costbilling/costdetail/warecostindex",
        name: "costbillingWarecostindex",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/costdetail/warecostindex"),
    },
    {
        path: "costbilling/costdetail/material",
        name: "costbillingMaterial",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/costdetail/material"),
    },
    {
        path: "costbilling/costdetail/service",
        name: "costbillingService",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/costdetail/service"),
    },
    // 账单管理
    {
        path: "costbilling/billmanage",
        name: "costbillingBillmanage",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billmanage/index"),
    },
    {
        path: "costbilling/billmanage/update",
        name: "costbillingManageUpdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billmanage/detail/index"),
    },
    {   //账单详情详明细
        path: "costbilling/billmanage/list",
        name: "costbillingManageUpdates",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billmanage/detail/list"),
    },
    // 调账
    {
        path: "costbilling/adjument/list",
        name: "costbillingAdjumentList",
        component: () => import(/* webpackChunkName: "bill" */ "@/views/costbilling/adjument/index"),
    },
    // 费率模板管理
    {
        path: "costbilling/customerrate/billtemplate/list",
        name: "costbillingRateTemplatelist",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/customerrate/billtemplate/index"),
    },
    {
        path: "costbilling/customerrate/billtemplate/update/:type",
        name: "costbillingRateTemplateupdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/customerrate/billtemplate/update"),
    },
    // 客户费率
    {
        path: "costbilling/customerrate/customerbill/list",
        name: "costbillingRateBilllist",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/customerrate/customerbill/index"),
    },
    {
        path: "costbilling/customerrate/customerbill/update/:type",
        name: "costbillingRateBillupdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/customerrate/customerbill/update"),
    },
    // 账单任务列表
    {
        path: "costbilling/billtask/list",
        name: "costbillingBillTaskList",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billtask/index"),
    },

    // 账户信息配置列表
    {
        path: "costbilling/billnews/list",
        name: "costbillingBillNewsList",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billnews/index"),
    },
    {
        path: "costbilling/billnews/update/:type",
        name: "costbillingBillNewsUpdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billnews/update"),
    },
    //子账号
    {
        path: "costbilling/subaccount/list",
        name: "costbillingSubAccountList",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/subaccount/index"),
    },
    // 燃油附加费
    {
        path: "costbilling/fuelextra/list",
        name: "costbillingfuelextraList",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/fuelextra/index"),
    },
    {
        path: "costbilling/fuelextra/update/:type",
        name: "costbillingfuelextraUpdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/fuelextra/update"),
    },
    // 客户计费系数配置
    {
        path: "costbilling/billcoefficient/list",
        name: "billCoefficientList",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billcoefficient/index"),
    },
    {
        path: "costbilling/billcoefficient/update/:type",
        name: "billCoefficientUpdate",
        component: () => import(/* webpackChunkName: "costbilling" */ "@/views/costbilling/billcoefficient/update"),
    },
]

